<template>
  <div>
    <Header :logoUrl="logoUrl" :desarrollo="desarrollo"/>
    <router-view />
    <Footer :brochureUrl="brochureUrl" />
  </div>
</template>

<script>
import Header from "../../core/Header.vue";
import Footer from "../../core/Footer.vue";
export default {
  name: "BosquesCasas",
  data() {
    return {
      desarrollo: "bosques_casas", 
      brochureUrl:'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/tres-marias/assets/brochure/BosquesTresMarias.pdf',
      logoUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/bosques/terrenoLogo/bosques_logo.png",
    };
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style>
:root {
  --animate-duration: 250ms;
  --animate-delay: 0.9s;
}
.quick {
  transition-duration: "0ms" !important;
}
</style>
